import BaseForm from "shared/form";

import Backdraft from "backdraft-app/src/backdraft";

import _ from "underscore";

Backdraft.plugin("Form", function(plugin) {
  plugin.initializer(function(app) {
    app.installPlugin("Base");

    class Form extends BaseForm {
      constructor(...args) {
        super(...args);

        this.on("cancel", this._navigateToIndex.bind(this));
        this.on("beforeSuccess", this._onBeforeSuccess.bind(this));
        this.on("success", this._onSuccess.bind(this));
      }

      _navigateToIndex() {
        app.navigate("");
      }

      _onBeforeSuccess(model) {
        this.trigger("afterSuccess", model);
      }

      _onSuccess() {
        if (this.navigateToIndex) {
          this._navigateToIndex();
        }
      }

      _getFormBindings() {
        // prefer bindings on the instance, but for deprecated callers also support findings on the global `app.view`)
        return this.formBindings || app.view.formBindings;
      }
    }

    Form.prototype.navigateToIndex = true;

    app.view.form = function(name, baseClassName, properties) {
      var baseClass = Form;
      if (arguments.length === 2) {
        properties = baseClassName;
      } else {
        baseClass = app.Views[baseClassName];
      }

      app.Views[name] = baseClass.extend(properties);
    };

    app.view.formHelpers = {
      bindMessageToFormField: function(view, type, name, attr, options) {
        var prefix = '';
        if (!options || options.addPrefix) {
          prefix = name + ' ';
        }

        if (!view.formBindings) {
          view.formBindings = [];
        }

        if (view.formBindings.indexOf(attr) === -1) {
          view.formBindings.push(attr);
        }

        return {
          observe: type + "s",
          update: function($el, errorHash, model, options) {
            var errorsForAttribute = errorHash[attr];
            if (errorsForAttribute) {
              $el.text(prefix + _.flatten([errorsForAttribute]).join(", "));
            } else {
              $el.text("");
            }

            app.view.formHelpers._toggleClassFromErrors(errorsForAttribute, type, $el);
          }
        };
      },

      // deprecated interface that uses the global `app.view` to store formBindings
      //  once all consumers are migrated, remove this wrapper
      bindErrorsToFormField: function(name, attr, options) {
        return app.view.formHelpers.bindMessageToFormField(app.view, "error", name, attr, options);
      },

      // deprecated interface that uses the global `app.view` to store formBindings
      //  once all consumers are migrated, remove this wrapper
      bindWarningsToFormField: function(name, attr, options) {
        return app.view.formHelpers.bindMessageToFormField(app.view, "warning", name, attr, options);
      },

      _toggleClassFromErrors: function(errorsForAttribute, type, el) {
        var targetFormGroup = el.closest(".sb-field-group");

        if (targetFormGroup.length) {
          // Warnings are mapped to invalid for now
          targetFormGroup.toggleClass('sb-field-group--invalid', !!errorsForAttribute);
        } else {
          el.closest(".form-group").toggleClass("has-" + type, !!errorsForAttribute);
        }
      }
    };
  });
});
